<template>
  <ik-image
    :path="path"
    :query-parameters="queryParameters"
    :transformation="transformation"
    :loading="loading"
    :height="height"
    :width="width" />
</template>

<script>
import '@/imagekit/index'
import { pathFromAWSUrl } from '@/imagekit/aws_path'

export default {
  name: 'IKImageS3Wrapper',
  props: {
    awsUrl: {
      type: String,
      required: true
    },
    // pass-through props for IKImage
    transformation: {
      type: Array,
      default() {
        return []
      }
    },
    queryParameters: {
      type: Object,
      default: () => null
    },

    loading: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    }
  },
  computed: {
    path() {
      return pathFromAWSUrl(this.awsUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
